import React from 'react';

/**
 * Same asset as the hero banner, so the footer logo costs no extra network
 * request — it is masked to the logo region at the top of that image.
 */
const HERO_URL = 'https://cdn.magicpatterns.com/uploads/4mQVXyQCDaLGqFgcxpbsZV/ChatGPT_Image_Sep_16,_2026,_06_41_37_PM.png';
interface BrandLogoProps {
  className?: string;
}
export function BrandLogo({
  className = ''
}: BrandLogoProps) {
  return <div role="img" aria-label="Winners Mindset — Life Division" className={`bg-no-repeat ${className}`} style={{
    aspectRatio: '350 / 130',
    backgroundImage: `url(${HERO_URL})`,
    backgroundSize: '530% auto',
    backgroundPosition: '50.1% 0%'
  }} data-id="element-1" data-mp="1ysuai8pijm8f" />;
}